// extracted by mini-css-extract-plugin
module.exports = {"main":"number_main__DbK4E"};